import { Directive, ElementRef, Input, OnChanges, Renderer2 } from '@angular/core';
import { TextShadow } from '../models';

@Directive({
    selector: '[textShadow]',
    standalone: false
})
export class TextShadowDirective implements OnChanges {
  @Input() textShadow!: TextShadow;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnChanges(): void {
    if (!this.textShadow || !this.textShadow.enabled) {
      this.renderer.removeStyle(this.el.nativeElement, 'text-shadow');
      return;
    }

    const shadow = this.buildShadow(this.textShadow);
    this.renderer.setStyle(this.el.nativeElement, 'text-shadow', shadow);
  }


  private buildShadow(settings: Partial<TextShadow>): string {
    const offsetX = this.sanitizeCssValue(settings.offsetX);
    const offsetY = this.sanitizeCssValue(settings.offsetY);
    const radius = this.sanitizeCssValue(settings.radius);
    const color = settings.color || 'black';

    return `${offsetX} ${offsetY} ${radius} ${color}`;
  }

  private sanitizeCssValue(value: string): string {
    if (this.isValidCssLength(value)) {
      return value;
    }
    
    return '0px';
  }

  private isValidCssLength(value: string): boolean {
    return /^-?\d*\.?\d+(px|em|rem|%|vw|vh)$/.test(value);
  }
}
